import styled from '@emotion/styled';
import { theme } from '@ublend-npm/aulaui-next';

export const Anchor = styled.a`
  color: ${theme.color.designSystem.purple70};
`;

export const PaddedSpan = styled('span')`
  padding-left: 0.1px;
`;
